const module = { name: 'Fandango/revealable', exports: {} }; const exports = module.exports;



const Styles = {
    UNHIDE: 'revealable--unhide',
    VISIBLE: 'revealable--visible'
}


const ANIMATION_DURATION = 320
function toggle(selector, show) {
    const elByID = document.getElementById(selector);
    const els = elByID ? [elByID] : [...document.querySelectorAll(selector)];
    if (!els?.length) {
        return;
    }
    els.forEach((el) => {
        show ? el.classList.add(Styles.UNHIDE) : el.classList.remove(Styles.UNHIDE);
        el.classList.add(Styles.VISIBLE);
        setTimeout(() => {
            el.classList.remove(Styles.VISIBLE);
        }, ANIMATION_DURATION);
    });
}
module.exports = {
    unhide(id) {
        toggle(id, true);
    },
    hide(id) {
        toggle(id, false);
    }
};
export default module.exports;